import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { createContextScope } from '@radix-ui/react-context';
import { Primitive } from '@radix-ui/react-primitive';
const ARTICLE_CARD_NAME = 'ArticleCard';
const IMAGE = 'ArticleCardImage';
const TITLE = 'ArticleCardTitle';
const CONTENT = 'ArticleCardContent';
const SUBTITLE = 'ArticleCardSubtitle';
const ID = 'ArticleCardId';
const [createArticleCardContext, createArticleCardScope] = createContextScope(ARTICLE_CARD_NAME, []);
const [ArticleCardProvider, useArticleCardContext] = createArticleCardContext(ARTICLE_CARD_NAME);
/************************************/
// ArticleCard
/************************************/
const ArticleCard = (props) => {
    const { __scopeArticleCard, children, article, ...rootProps } = props;
    return (_jsx(ArticleCardProvider, { article: article, scope: __scopeArticleCard, children: _jsx(Primitive.div, { ...rootProps, children: children }) }));
};
ArticleCard.displayName = ARTICLE_CARD_NAME;
const ArticleCardImage = React.forwardRef((props, forwardRef) => {
    const { src, __scopeArticleCard, ...imageProps } = props;
    const context = useArticleCardContext(IMAGE, __scopeArticleCard);
    return _jsx(Primitive.img, { src: src || context.article?.image_url, ...imageProps, ref: forwardRef });
});
ArticleCardImage.displayName = IMAGE;
const ArticleCardTitle = React.forwardRef((props, forwardRef) => {
    const { asTitle = 'h2', children, __scopeArticleCard, ...titleProps } = props;
    const context = useArticleCardContext(TITLE, __scopeArticleCard);
    const Component = Primitive[asTitle];
    return (_jsx(Component, { ...titleProps, ref: forwardRef, children: children || context.article?.title }));
});
ArticleCardTitle.displayName = TITLE;
const ArticleCardId = React.forwardRef((props, forwardRef) => {
    const { children, __scopeArticleCard, ...idProps } = props;
    const { article: { id = '' } = {} } = useArticleCardContext(ID, __scopeArticleCard);
    return (_jsx(Primitive.div, { ...idProps, ref: forwardRef, children: children || id }));
});
ArticleCardId.displayName = ID;
const ArticleCardContent = React.forwardRef((props, forwardRef) => {
    const { children, __scopeArticleCard, ...contentProps } = props;
    const context = useArticleCardContext(CONTENT, __scopeArticleCard);
    return (_jsx(Primitive.div, { ...contentProps, ref: forwardRef, children: children || (_jsxs(_Fragment, { children: [_jsx(ArticleCardImage, {}), " ", context.article?.description, ' '] })) }));
});
ArticleCardContent.displayName = CONTENT;
const ArticleCardSubtitle = React.forwardRef((props, forwardRef) => {
    const { children, __scopeArticleCard, ...subtitleProps } = props;
    const context = useArticleCardContext(SUBTITLE, __scopeArticleCard);
    return (_jsx(Primitive.div, { ...subtitleProps, ref: forwardRef, children: children || context.article?.subtitle }));
});
const Root = ArticleCard;
const Image = ArticleCardImage;
const Title = ArticleCardTitle;
const Content = ArticleCardContent;
const Id = ArticleCardId;
const Subtitle = ArticleCardSubtitle;
export { createArticleCardScope, Root, Content, Image, Title, Subtitle, Id, ArticleCard, ArticleCardContent, ArticleCardImage, ArticleCardTitle, ArticleCardId, ArticleCardSubtitle, };
